import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { DateInput } from "../inputs/date-input"

interface DateFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof DateInput>, "value" | "onChange" | "error"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function DateField<T extends FieldValues>({ field, id, description, ...props }: DateFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <DateInput id={id} value={field.value} onChange={field.onChange} error={!!error} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  birthDate: Date;
}

<FormField
  control={form.control}
  name="birthDate"
  render={({ field }) => (
    <DateField<FormData>
      field={field}
      id="birthDate"
      label="Date of Birth"
      description="Enter your date of birth"
      placeholder="Select your birth date"
    />
  )}
/>
*/
